import { useCallback, useState } from 'react';
import { Option } from '../../components/search/admin-dashboard-tables/interfaces';

/**
 * TODO: At the moment, toggling items with checkboxes causes a re-render.
 * This re-render causes unnecessary calls to Algolia. See if you can figure
 * out a way to prevent this!
 */

const useBulkSelected = (
  toggleAllCallback?: (hits: number[]) => void,
) => {
  const [bulkAction, setBulkAction] = useState<Option>({
    label: '',
    value: '',
  });
  const [bulkSelected, setBulkSelected] = useState<Array<number>>([]);
  const [allSelected, setAllSelected] = useState(false);
  const [hits, setHits] = useState<Array<any>>([]);

  const updateBulkSelected = useCallback((id: number) => {
    if (allSelected) {
      setAllSelected(false);
    }
    if (bulkSelected.includes(id)) {
      const newBulkSelected = bulkSelected.filter((item: number) => item !== id);
      setBulkSelected(newBulkSelected);
    } else {
      setBulkSelected([...bulkSelected, id]);
    }
  }, [bulkSelected, setBulkSelected, allSelected, setAllSelected]);

  const toggleAllSelected = useCallback((toggleOn: boolean) => {
    setAllSelected(toggleOn);
    if (toggleOn) {
      setBulkSelected(hits);
      if (toggleAllCallback) {
        toggleAllCallback(hits);
      }
    } else {
      setBulkSelected([]);
      if (toggleAllCallback) {
        toggleAllCallback([]);
      }
    }
  }, [hits, toggleAllCallback]);

  const clearBulkSelected = useCallback(() => {
    if (bulkSelected.length > 0) {
      if (allSelected) {
        setAllSelected(false);
      }
      setBulkSelected([]);
    }
  }, [bulkSelected, allSelected]);

  return {
    bulkAction,
    setBulkAction,
    updateBulkSelected,
    bulkSelected,
    toggleAllSelected,
    allSelected,
    setAllSelected,
    setHits,
    clearBulkSelected,
  };
};

export default useBulkSelected;
